import { logAppError } from 'Helpers/logger'
import type { GroupStats } from '../model'

export const getRecipientsListUrlToNavigate = (
  statProp: keyof GroupStats,
  idGroup: number,
): string => {
  return `/recipients/list?sch=${getChannelTypeFromStat(
    statProp,
  )}&ssst=${getSubsTypeFromStat(statProp)}&sig=${idGroup}`
}

const getChannelTypeFromStat = (statProp: keyof GroupStats): string => {
  const errMsg = `navigate to stat: ${statProp} not handled`
  switch (statProp) {
    case 'EmailSubscribed':
    case 'EmailPending':
    case 'EmailUnsubscribed':
      return 'email'
    case 'SmsSubscribed':
    case 'SmsPending':
    case 'SmsUnsubscribed':
      return 'sms'
    default:
      console.error(errMsg)
      logAppError({
        Component: 'GroupsList',
        Method: 'getChannelTypeFromStat',
        appError: new Error(errMsg),
      })
  }
  return ''
}

const getSubsTypeFromStat = (statProp: keyof GroupStats): string => {
  const errMsg = `navigate to stat: ${statProp} not handled`
  switch (statProp) {
    case 'EmailSubscribed':
    case 'SmsSubscribed':
      return 'optin'
    case 'EmailPending':
    case 'SmsPending':
      return 'pending'
    case 'EmailUnsubscribed':
    case 'SmsUnsubscribed':
      return 'optout'
    default:
      console.error(errMsg)
      logAppError({
        Component: 'GroupsList',
        Method: 'getSubsTypeFromStat',
        appError: new Error(errMsg),
      })
  }
  return ''
}
